import { UserRoles } from '../enums/user-role';

export const Constants = {
  CONTACTS: [
    { id: 1, description: 'Primary' },
    { id: 2, description: 'Secondary' },
    { id: 3, description: 'Other' },
  ],
  DELIVERY_MOTHODS: [
    { id: 1, description: 'Postal Mail' },
    { id: 2, description: 'Electronic Mail' },
    { id: 3, description: 'Parent Portal' },
  ],
  uploadFileTypeAllowed: [
    '.jpg',
    '.jpeg',
    '.png',
    '.tif',
    '.tiff',
    '.pdf',
    '.txt',
    '.xls',
    '.xlsx',
    '.doc',
    '.docx',
    '.pptx',
    '.svg',
    '.pptx',
  ],
  maxFileuploadSize: 30000000, //Unit is in bytes which is 30MB
  minFileuploadSize: 300, //Unit is in bytes which is 1KB
  UPLOAD_DOCUMENT_TYPES: [
    // {
    //     id: 1,
    //     description: 'Consent for Initial Evaluation',
    //     docType: 18
    // },
    {
      id: 2,
      description: 'Consent for Initial Provision of Services',
      docType: 19,
    },
    {
      id: 3,
      description: 'Preschool Acceptance Letter',
      docType: 20,
    },
    {
      id: 4,
      description: 'DEP 1',
      docType: 17,
    },
    {
      id: 5,
      description: 'STAC',
      docType: '62',
    },
    {
      id: 6,
      description: 'Partially Served Notice',
      docType: '63',
    },
    {
      id: 7,
      description: 'Variance',
      docType: '94',
    },
    {
      id: 8,
      description: 'Consent for Waiver of IEP Meeting',
      docType: '57',
    },
    {
      id: 9,
      description: 'Consent for Additional Assessments',
      docType: '80',
    },
    {
      id: 10,
      description: 'Progress Report',
      docType: '105',
    },
    {
      id: 11,
      description: 'Functional Behavior Assessment (FBA)',
      docType: '39',
    },
    {
      id: 12,
      description: 'Withdrawal Initial Referral From Special Education Process',
      docType: '82',
    },
    {
      id: 13,
      description: 'Completed by Physician',
      docType: '117',
      schoolAgeOnly: true,
    },
    {
      id: 14,
      description: 'Completed by Parent',
      docType: '118',
      schoolAgeOnly: true,
    },
    {
      id: 15,
      description: 'Request For Release of Records',
      docType: '119',
      schoolAgeOnly: true,
    },
    {
      id: 16,
      description: 'Parent Withdrawal of Consent',
      docType: '113',
    },
    {
      id: 17,
      description: 'Parent Notice of Intent',
      docType: '124',
    },
  ],
  PROVIDER_SERVICES: [
    { id: 'Special Class' },
    { id: 'SCIS' },
    { id: 'SEIT' },
    { id: 'Related Service' },
    { id: 'Related Service Only' },
  ],
  IEP_MEETINGTYPE: [
    {
      id: 1,
      description: 'Initial',
    },
    { id: 5, description: 'Annual Review' },
    { id: 4, description: 'Mandated 3-Year' },
    {
      id: 2,
      description: 'Reevaluation',
    },
    {
      id: 3,
      description: 'Additional Reevaluation',
    },
  ],
  EIOutreachToFromDropdown: [
    {
      id: 1,
      description: 'Parent/Guardian/Foster Parent',
      sortOrder: 1,
      value: 'Par/Guar/Fost Parent',
      indicator: null,
      extDescr: null,
    },
    {
      id: 2,
      description: 'CPSE - CC, Admin, Chairperson',
      sortOrder: 2,
      value: 'CPSE-CC,Admin,Chairp',
      indicator: null,
      extDescr: null,
    },
    {
      id: 3,
      description: 'EI Transition Team - TC, ™',
      sortOrder: 3,
      value: 'EI Transition Team',
      indicator: null,
      extDescr: null,
    },
    {
      id: 4,
      description: 'Foster Care Planner/Agency',
      sortOrder: 4,
      value: 'Foster Planner/Agenc',
      indicator: null,
      extDescr: null,
    },
    {
      id: 5,
      description: 'EISC/EI Regional Office',
      sortOrder: 5,
      value: 'EISC/EI Reg Off',
      indicator: null,
      extDescr: null,
    },
    {
      id: 6,
      description: 'MDE',
      sortOrder: 6,
      value: 'MDE',
      indicator: null,
      extDescr: null,
    },
    {
      id: 7,
      description: 'Preschool Program',
      sortOrder: 7,
      value: 'Preschool Program',
      indicator: null,
      extDescr: null,
    },
    {
      id: 8,
      description: 'Other',
      sortOrder: 8,
      value: 'Other',
      indicator: null,
      extDescr: null,
    },
  ],

  languageChangeRestrictedAssessments: [
    {
      id: 29,
      description: 'Psychiatric Assessment',
    },
    {
      id: 31,
      description: 'Psychoeducational Assessment',
    },
    {
      id: 32,
      description: 'Psychological Assessment',
    },
    {
      id: 33,
      description: 'Psychological Update',
    },
    {
      id: 36,
      description: 'Speech and Language Assessment',
    },
  ],
  releaseNotes: {
    DOE_EXTERNAL:
      'https://drive.google.com/drive/u/1/folders/1txkPm1csCU3VR8F1tfi1i5ka2bf4q_8A',
    NON_DOE_EXTERNAL:
      'https://nycdoe.sharepoint.com/sites/SEO-SEDMSReview/SitePages/CollabHome.aspx',
  },
  kipRoleIds: [
    56, 57, 43, 47, 41, 54, 45, 51, 50, 55, 49, 40, 42, 44, 48, 52, 46, 53,
  ],
  review: 'review',
  SCHL_YR_PM_DROPDOWN: [
    { id: 1, description: 'Current School Year' },
    { id: 2, description: 'Current Summer Year' },
    { id: 3, description: 'Past School Year' },
    { id: 4, description: 'Past Summer  Year' },
  ],
  STUDENT_TYPE: [
    { id: 1, description: 'Preschool' },
    { id: 0, description: 'School Age' },
  ],
  MANDATE_TERM: [
    { id: 1, description: '10M' },
    { id: 0, description: '12M' },
  ],
  SORT_BY_PM_DROPDOWN: [
    { id: 11, description: 'First Name: A to Z' },
    { id: 12, description: 'First Name: Z to A' },
    { id: 1, description: 'Last Name: A to Z' },
    { id: 2, description: 'Last Name: Z to A' },
    { id: 3, description: 'Age: Ascending' },
    { id: 4, description: 'Age: Descending' },
    { id: 5, description: 'Grade: Ascending' },
    { id: 6, description: 'Grade: Descending' },
    { id: 7, description: 'Admin DBN: A to Z' },
    { id: 8, description: 'Admin DBN: Z to A' },
    { id: 9, description: 'Status: A to Z' },
    { id: 10, description: 'Status: Z to A' },
  ],
  SORT_BY_ENCOUNTER_DROPDOWN: [
    { id: 1, description: 'Status: A to Z' },
    { id: 2, description: 'Status: Z to A' },
    { id: 3, description: 'Session: A to Z' },
    { id: 4, description: 'Session: Z to A' },
    { id: 11, description: 'Student Name: A to Z' },
    { id: 12, description: 'Student Name: Z to A' },
  ],
  MONO_BILI_DROPDOWN: [
    { id: 0, description: 'Monolingual' },
    { id: 1, description: 'Bilingual' },
  ],
  BUNDLE_STATUS_DROPDOWN: [
    { id: 44, description: 'Pending Schedule' },
    { id: 71, description: 'Contract Assistance Requested' },
    { id: 73, description: 'Primary Agency Does not Exist' },
    { id: 88, description: 'Contract Agency Rejected' },
    { id: 90, description: 'Pending Contract Agency Responses' },
  ],
  PNI_DRPDWN: [
    { id: 1, description: 'Signed PNI Received' },
    { id: 2, description: 'Signed PNI not Received' },
    { id: 3, description: 'KIP' },
  ],
  RATE_RANGE: [{
    id: 1,
    description: '$0-$299'
  },
  {
    id: 2,
    description: '$300-$599'
  },
  {
    id: 3,
    description: '$600-$899'
  },
  {
    id: 4,
    description: '$900-$1199'
  },
{
  id:5,
  description:'$1200+'
}],
  MANDATE_TYPE_OPTIONS: [
    { label: 'Mandates with No Request', value: 'noRequest' },
    { label: 'Fee for Service', value: 'feeService' },
    { label: 'Defined Weekly Schedule', value: 'weeklySchedule' },
    { label: 'Assign to Caseload Requests', value: 'assignCaseload' },
  ],
  ASSESSMENT_TYPE_OPTIONS: [
    { label: 'Incoming Requests', value: 'incomingRequest' },
    { label: 'Request to Confirm Capacity', value: 'confirmCapacity' },
    { label: 'AA Process', value: 'aaProcess' },
  ],
  PROVIDER_TYPE_DRPDWN: [
    { id: 1, description: 'NYCPS' },
    { id: 3, description: 'Contract Agency' },
    { id: 4, description: 'Location' },
  ],
  PROVIDER_TYPES_ROLE_BASED : {
    NYCPS: { id: 4, description: 'NYCPS' },
    CONTRACT_AGENCY: { id: 3, description: 'Contract Agency' },
    CONTRACT_AGENCY_DWS: { id: 3, description: 'Contract Agency (DWS)' },
   
  },

  NOTIFICATION_ERROR_MESSAGE:
    'Fetching notifications failed. Please try again later.',
  MONTHS: [
    { id: 1, description: 'January' },
    { id: 2, description: 'February' },
    { id: 3, description: 'March' },
    { id: 4, description: 'April' },
    { id: 5, description: 'May' },
    { id: 6, description: 'June' },
    { id: 7, description: 'July' },
    { id: 8, description: 'August' },
    { id: 9, description: 'September' },
    { id: 10, description: 'October' },
    { id: 11, description: 'November' },
    { id: 12, description: 'December' },
  ],

  DAYS: [
    { id: 1, description: 'Sunday', value: 'Su' },
    { id: 2, description: 'Monday', value: 'Mo' },
    { id: 3, description: 'Tuesday', value: 'Tu' },
    { id: 4, description: 'Wednesday', value: 'We' },
    { id: 5, description: 'Thursday', value: 'Th' },
    { id: 6, description: 'Friday', value: 'Fr' },
    { id: 7, description: 'Saturday', value: 'Sa' },
  ],

  WEEKORDER: [
    { id: 1, description: 'First', value: 'Su' },
    { id: 2, description: 'Second', value: 'Mo' },
    { id: 3, description: 'Third', value: 'Tu' },
    { id: 4, description: 'Fourth', value: 'We' },
    { id: 5, description: 'Last', value: 'Th' },
  ],

  DEFAULT_OPTION: { id: null, description: 'Select' },

  MANDATE_STATUS: [
    { id: 85, description: 'Assigned' },
    { id: 87, description: 'Un Assigned' },
    { id: 118, description: 'Partially Assigned' },
  ],
  ASSIGNMENT_STATUS: [
    { id: 44, description: 'Pending Schedule' },
    { id: 51, description: 'Awaiting Location Provider' },
    { id: 54, description: 'Awaiting Service Confirmation' },
    { id: 55, description: 'Receiving' },
    { id: 60, description: 'Rejected by Provider' },
    { id: 61, description: 'Terminated Without First Attend' },
    { id: 64, description: 'Terminated' },
    { id: 66, description: 'Pending Termination' },
    { id: 67, description: 'Awaiting Provider Assignment' },
    { id: 71, description: 'Contract Assistance Requested' },
    { id: 75, description: 'Awaiting Contract Agency' },
    { id: 76, description: 'Awaiting Contract Agency Provider' },
    { id: 78, description: 'Awaiting Location Provider Confirmation' },
    { id: 81, description: 'Awaiting First Attend' }
  ],
  SERVICE_MODELS: [
    { id: 1, description: 'Fee for Service' },
    { id: 2, description: 'Defined Weekly Schedule' },
  ],
  SERVICE_TYPES: [
    { id: 5, description: 'Adaptive Physical Education' },
    { id: 2, description: 'Audiology Services' },
    { id: 8, description: 'Counselling Services' },
    { id: 14, description: 'Hearing Education Services' },
    { id: 18, description: 'Nurse - Transportation' },
    { id: 7, description: 'Occupational Therapy' },
    { id: 4, description: 'Oral Transliterator' },
    { id: 9, description: 'Orientation and Mobility Services' },
    { id: 7, description: 'Para - Alternate Placement' },
    { id: 3, description: 'Para - Behavior Support' },
    { id: 2, description: 'Para - Health' },
    { id: 1, description: 'Para - Orientation and Mobility Services' },
    { id: 14, description: 'Para - Toileting' },
    { id: 4, description: 'Para - Transportation' },
    { id: 11, description: 'Parent Counselling and Training' },
    { id: 6, description: 'Physical Therapy' },
    { id: 1, description: 'S.E. Teacher Support Service (SETSS)' },
    { id: 3, description: 'Sign Language Interpreter' },
    { id: 1, description: 'Speech Language Therapy' },
    { id: 15, description: 'Vision Education Services' }
  ],
  AGES: [
    { id: 3, description: '3' },
    { id: 4, description: '4' },
    { id: 5, description: '5' },
    { id: 6, description: '6' },
    { id: 7, description: '7' },
    { id: 8, description: '8' },
    { id: 9, description: '9' },
    { id: 10, description: '10' },
    { id: 11, description: '11' },
    { id: 12, description: '12' },
    { id: 13, description: '13' },
    { id: 14, description: '14' },
    { id: 15, description: '15' },
    { id: 16, description: '16' },
    { id: 17, description: '17' },
    { id: 18, description: '18' },
    { id: 19, description: '19' },
    { id: 20, description: '20' },
    { id: 21, description: '21' },
  ],
  CSE_REF_VALUE: [
    { refValue: '01', id: 1, description: 'CS01' },
    { refValue: '02', id: 2, description: 'CS02' },
    { refValue: '03', id: 3, description: 'CS03' },
    { refValue: '04', id: 4, description: 'CS04' },
    { refValue: '05', id: 5, description: 'CS05' },
    { refValue: '06', id: 6, description: 'CS06' },
    { refValue: '07', id: 7, description: 'CS07' },
    { refValue: '08', id: 8, description: 'CS08' },
    { refValue: '09', id: 9, description: 'CS09' },
    { refValue: '10', id: 10, description: 'CS10' },
    { refValue: '11', id: 11, description: 'CS11' },
    { refValue: '12', id: 12, description: 'CS12' },
    { refValue: '13', id: 13, description: 'CS13' },
    { refValue: '14', id: 14, description: 'CS14' },
    { refValue: '15', id: 15, description: 'CS15' },
    { refValue: '16', id: 16, description: 'CS16' },
    { refValue: '17', id: 17, description: 'CS17' },
    { refValue: '18', id: 18, description: 'CS18' },
    { refValue: '19', id: 19, description: 'CS19' },
    { refValue: '20', id: 20, description: 'CS20' },
    { refValue: '21', id: 21, description: 'CS21' },
    { refValue: '22', id: 22, description: 'CS22' },
    { refValue: '23', id: 23, description: 'CS23' },
    { refValue: '24', id: 24, description: 'CS24' },
    { refValue: '25', id: 25, description: 'CS25' },
    { refValue: '26', id: 26, description: 'CS26' },
    { refValue: '27', id: 27, description: 'CS27' },
    { refValue: '28', id: 28, description: 'CS28' },
    { refValue: '29', id: 29, description: 'CS29' },
    { refValue: '30', id: 30, description: 'CS30' },
    { refValue: '31', id: 31, description: 'CS31' },
    { refValue: '32', id: 32, description: 'CS32' },
    { refValue: '75', id: 75, description: 'CS75' },
    { refValue: '79', id: 79, description: 'CS79' },
    { refValue: '84', id: 84, description: 'CS84' },
    { refValue: '88', id: 88, description: 'CS88' }
  ],
  CSE: [
    { refValue: 'CS01', id: 1, },
    { refValue: 'CS02', id: 2, },
    { refValue: 'CS03', id: 3, },
    { refValue: 'CS04', id: 4, },
    { refValue: 'CS05', id: 5, },
    { refValue: 'CS06', id: 6, },
    { refValue: 'CS07', id: 7, },
    { refValue: 'CS08', id: 8, },
    { refValue: 'CS09', id: 9, },
    { refValue: 'CS10', id: 10 },
    { refValue: 'CS11', id: 11 }
  ],
  RATIO_NUMBER_1: [
    { id: 1, description: '6 or less' },
    { id: 2, description: '7' },
    { id: 3, description: '8' },
    { id: 4, description: '9' },
    { id: 5, description: '10' },
    { id: 6, description: '11' },
    { id: 7, description: '12' },
    { id: 8, description: '13' },
    { id: 9, description: '14' },
    { id: 10, description: '15 or more' },
  ],
   RATIO_NUMBER_2: [
    { id: 1, description: '1' },
    { id: 2, description: '2' },
    { id: 3, description: '3' },
    { id: 4, description: '4' },
    { id: 5, description: '5' },
    { id: 6, description: '6' },
    { id: 7, description: '7' },
    { id: 8, description: '8' },
    { id: 9, description: '9' },
    { id: 10, description: '10' },
    { id: 10, description: '11' },
    { id: 10, description: '12' },
    { id: 10, description: '13' },
    { id: 10, description: '14' },
    { id: 10, description: '15' },
  ],
  RATIO_NUMBER_3: [
    { id: 1, description: '1 or less' },
    { id: 2, description: '2' },
    { id: 3, description: '3' },
    { id: 4, description: '4 or more' },
  ],
  RATIO_NUMBER_4: [
    { id: 1, description: '1' },
    { id: 2, description: '2' },
    { id: 3, description: '3' },
    { id: 4, description: '4' },
  ],

  EA_STATUS: [
    { id: 1, description: 'Pending Assignment' },
    { id: 99, description: 'Withdrawn' },
    { id: 100, description: 'Declined' },
    { id: 101, description: 'Ready to Award' },
    { id: 108, description: 'AA Issued/Awaiting Independent Provider' },
    { id: 90, description: 'Pending Contract Agency Response' },
    { id: 47, description: 'Pending Assignment' },
    { id: 44, description: 'Pending Schedule' },
    { id: 28, description: 'Scheduled' },
    { id: 26, description: 'Rescheduled' },
    { id: 3, description: 'Pending Review' },
    { id: 35, description: 'Pending Approval' },
    { id: 24, description: 'Finalized' },
  ],
  DECISION_OPTIONS: [
    { id: '1', description: 'Approved' },
    { id: '2', description: 'Denied' },
  ],
  EVALUATOR_TYPES_STATUS: [
    { id: 4, description: 'Request for Assistance' },
    { id: 2, description: 'Internal Assignment' },
    { id: 3, description:  'Provided by Parent'},
  ],
}

export interface IepConstants {
  relatedServices: string;
  assistiveTechnology: string;
  seitDescription: string;
}

export const iepConstants: IepConstants = {
  relatedServices: 'Related Services',
  assistiveTechnology: 'Assistive Technology',
  seitDescription: 'Special Education Itinerant Teacher Services (SEIT)',
};

export interface ContactDescription {
  primary: string;
  secondary: string;
}

export const contactDescriptions: ContactDescription = {
  primary: 'Primary',
  secondary: 'Secondary',
};

export interface GridRoutes {
  eiTransition: string;
  eventLog: string;
}

export interface DashboardLabels {
  upcomingKpi: string;
}

export const gridRoutes: GridRoutes = {
  eiTransition: 'eitransition',
  eventLog: 'EventLog',
};

export const dashboardLabels: DashboardLabels = {
  upcomingKpi: 'Upcoming KPI',
};

export const FILESIZEMESSAGE: string =
  'File Size accepted is between 1 KB to 28 MB';

export const ICON_WIDTH_INDEX: number = 0;

export const ICON_HEIGHT_INDEX: number = 1;

export const ICON_SVG_PATH_INDEX: number = 4;

export const SEARCH_DEBOUNCE_TIME_MS: number = 300;

export const TAKE_ONE: number = 1;

export const SERIES: string = 'SERIES';

export const DASHBOARD_DATA_DEBOUNCE_TIME_MS: number = 300;
export enum CSERole {
  Chairperson = 7,
  SEEPPO = 8, // Special Ed Placement Officer
  SupervisorOfPsychologist = 9,
  SchoolPsychologist = 10,
  SocialWorker = 11,
  TeacherSpecialEd = 12,
  TeacherGeneralEd = 13,
  ClericalFamilyWorker = 14, // Clerical/Family Worker/PAA/Community Coordinator
  CPSEAdministrator = 15,
  Audiologist = 16,
  SpeechTeacher = 17,
  OccupationalTherapist = 18,
  PhysicalTherapist = 19,
  SBSchoolPsychologist = 42,
}

export const roleIdsForCSE: number[] = [
  CSERole.Chairperson,
  CSERole.SEEPPO,
  CSERole.SupervisorOfPsychologist,
  CSERole.SchoolPsychologist,
  CSERole.SocialWorker,
  CSERole.TeacherSpecialEd,
  CSERole.TeacherGeneralEd,
  CSERole.ClericalFamilyWorker,
  CSERole.CPSEAdministrator,
  CSERole.Audiologist,
  CSERole.SpeechTeacher,
  CSERole.OccupationalTherapist,
  CSERole.PhysicalTherapist,
  CSERole.SBSchoolPsychologist,
];

export enum ServiceEntryAction {
  Create = 'Create Service Entry',
  Edit = 'Edit Service Entry',
  Review = 'Review Service Entry',
  View = 'View Service Entry',
  ViewSubmissionDetails = 'View Submission Details',
  ViewProviderDetails = 'View Provider Details',
  Delete = 'Delete Service Entry',
}

export const NON_DOE_APPLIED_BEHAVIOR_ANALYST: number[] = [
  UserRoles.RSC_AppliedBehaviorAnalyst,
  UserRoles.RSI_AppliedBehaviorAnalyst,
  UserRoles.SpecialEducationTeacher
];

export const PROVIDER_TYPES = {
  External: 'External Provider',
  Independent: 'Independent Provider',
  Location: 'Location Provider'
};
export const RFD_STATUS_TEXT = {
    ReasonForDelay: 'Reason for Delay Needed'
};

export const LANGUAGE_OTHER_ID = 151;

export const MAX_PAGE_JUMP_COUNT = 1000;